import type { NotificationType, CTAType, DeviceNotificationBuilder } from './DeviceNotificationBuilder';

/**
 * Structure of the Device Notification.
 * @param {string} id - Unique ID of the notification, formed as 'device id' + 'notification'.
 * @param {NotificationType} type - Type of the notification.
 * @param {boolean} dismissable - If the notification can be dismissed.
 * @param {string} heading.global - Global heading of the notification, used in main view.
 * @param {string} heading.local - Local heading of the notification, used in Device Drawer.
 * @param {string} message - Message of the notification.
 * @param {CTAType} ctaGlobal - CTA of the notification, used in main view.
 * @param {CTAType} ctaLocal - CTA of the notification, used in Device Drawer.
 * @param {string} error - Error message of the notification.
 */
export class DeviceNotification {
	id: string;
	type: NotificationType;
	priority: number;
	dismissable: boolean;
	heading: {
		global: string;
		local: string;
	};
	message?: string;
	messageHighlight?: string;
	ctaGlobal?: CTAType;
	ctaLocal?: CTAType;
	error?: string;

	constructor(builder: DeviceNotificationBuilder) {
		this.id = builder.getId();
		this.type = builder.getType();
		this.priority = builder.getPriority();
		this.dismissable = builder.getDismissable();
		this.heading = builder.getHeading();
		this.message = builder.getMessage();
		this.messageHighlight = builder.getMessageHighlight();
		this.ctaGlobal = builder.getCtaGlobal();
		this.ctaLocal = builder.getCtaLocal();
		this.error = builder.getError();
	}
}
